import Resizer from 'react-image-file-resizer';

/**
 * Shared image resize used before uploading a user or building photo.
 *
 * Lived in dashboard-add-new-building.tsx until 2026-09-14, when that screen was removed --
 * buildings are created in supervision-frontend only (CLAUDE.md, Shared Database, decided
 * 2026-07-18). Three screens imported it from there, two of them about users rather than
 * buildings, so it moved here rather than being deleted with its former host.
 */
export const resizeImage = (file: File): Promise<Blob> => {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    Resizer.imageFileResizer(
      file, // the file from input
      800, // max width
      800, // max height
      'JPEG', // compress format
      100, // quality
      0, // rotation
      uri => {
        // Assert the uri as Blob
        resolve(uri as Blob);
      },
      'blob' // output type as blob to append directly to formData
    );
  });
};
